export const zeroAddress = '0x0000000000000000000000000000000000000000';
//# sourceMappingURL=address.js.map